import { render, staticRenderFns } from "./MenuExterno.vue?vue&type=template&id=1e9e4978&scoped=true"
import script from "./MenuExterno.vue?vue&type=script&lang=js"
export * from "./MenuExterno.vue?vue&type=script&lang=js"
import style0 from "./MenuExterno.vue?vue&type=style&index=0&id=1e9e4978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9e4978",
  null
  
)

export default component.exports